import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { getSettingNextJSRSCBrandFirstCategoryPageBlockList } from "@faire/retailer-visitor-shared/settings/getSettingNextJSRSCBrandFirstCategoryPageBlockList";
import { getSettingNextJSRSCProductFirstCategoryPageAllowList } from "@faire/retailer-visitor-shared/settings/getSettingNextJSRSCProductFirstCategoryPageAllowList";
import { getSettingSDUICategoryPagePathNavigationPaths } from "@faire/retailer-visitor-shared/settings/getSettingSDUICategoryPagePathNavigationPaths";
export var isRSCCategoryNavigationPath = function(navigationPath) {
    var productFirstC1CategoryUrlIds = getSettingNextJSRSCProductFirstCategoryPageAllowList();
    var seasonalHubUrlIds = getSettingSDUICategoryPagePathNavigationPaths();
    var brandFirstUrlIds = getSettingNextJSRSCBrandFirstCategoryPageBlockList();
    var rscCategoryUrlIds = _to_consumable_array(productFirstC1CategoryUrlIds).concat(_to_consumable_array(seasonalHubUrlIds));
    var navigationPathList = navigationPath.split("|");
    var rootUrlId = navigationPathList[0];
    var currentUrlId = navigationPathList[navigationPathList.length - 1];
    var isRSCRootCategory = rscCategoryUrlIds.some(function(urlId) {
        return rootUrlId === urlId;
    });
    var isCurrentCategoryBrandFirst = brandFirstUrlIds.some(function(urlId) {
        return currentUrlId === urlId;
    });
    return isRSCRootCategory && !isCurrentCategoryBrandFirst;
};
